var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { isValidElement, cloneElement } from 'react';
import styled from 'styled-components';
import isValueSelected from './isValueSelected';
export var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  border-radius: 0.1875rem;\n  > button:not(:first-child) {\n    margin-left: -0.0625rem;\n    border-left: 0.0625rem solid ", ";\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  > button:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n"], ["\n  display: inline-flex;\n  border-radius: 0.1875rem;\n  > button:not(:first-child) {\n    margin-left: -0.0625rem;\n    border-left: 0.0625rem solid ", ";\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  > button:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n"])), function (_a) {
    var greyNormal = _a.theme.greyNormal;
    return greyNormal.color.normal;
});
var ToggleButtonGroup = function (props) {
    var _a = props, children = _a.children, onChange = _a.onChange, value = _a.value;
    var handleExclusiveChange = function (event, buttonValue) {
        if (!onChange) {
            return;
        }
        onChange(event, buttonValue);
    };
    return (React.createElement(StyledContainer, { role: "group" }, React.Children.map(children, function (child) {
        if (!isValidElement(child)) {
            return null;
        }
        var _a = child.props, selected = _a.selected, childValue = _a.childValue;
        return cloneElement(child, {
            onClick: handleExclusiveChange,
            selected: selected === undefined ? isValueSelected(childValue, value) : selected,
            size: 'medium',
        });
    })));
};
export default ToggleButtonGroup;
var templateObject_1;
//# sourceMappingURL=index.js.map